import { createFileRoute } from "@tanstack/react-router";
import SaintVsTraditionalPage from "@/pages/learn/SaintVsTraditionalPage";
import { pageSaintVsTraditional } from "@/pages/learn/learnDataSaintVsTraditional";
export const Route = createFileRoute("/learn/saint-vs-traditional-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "SAINT® vs TMS: 7 Key Differences (Schedule, Targeting, Results) | Neuro Wellness",
        },
        {
          name: "description",
          content:
            'SAINT® vs regular TMS and 5-day "accelerated TMS": how targeting, schedule, device, age limits, results and cost really differ.',
        },
        {
          property: "og:title",
          content:
            "SAINT® vs TMS: 7 Key Differences (Schedule, Targeting, Results) | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            'SAINT® vs regular TMS and 5-day "accelerated TMS": how targeting, schedule, device, age limits, results and cost really differ.',
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/saint-vs-traditional-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/saint-vs-traditional-tms",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageSaintVsTraditional.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintVsTraditionalPage />;
}
